export default __webpack_public_path__ + "static/media/img.c299fc1d.png";